export const layoutStyle = {
  layoutMenuWrapper: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: '#181818',
    padding: '20px 0 20px 0',
    position: 'sticky',
    top: 0,
    zIndex: 15,
  },
  layoutMenu: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    maxWidth: 1500,
    width: '100%',
    px: {
      xs: 2,
    },
  },
  layoutMenuLinks: {
    display: {
      lg: 'flex',
      xs: 'none',
    },
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 2,
  },
  layoutMenuLink: {
    color: 'white',
    textDecoration: 'none',
    fontWeight: 500,
    fontSize: 15,
    '&:hover': {
      color: '#e3cc33',
      textDecoration: 'none',
      transition: 'color 0.3s ease',
    },
  },
  layoutHeaderRightMenu: {
    display: {
      xs: 'none',
      lg: 'flex',
    },
    alignItems: 'center',
    justifyContent: 'center',
  },

  layoutContentWrapper: {
    mx: {
      xs: 2,
      sm: 5,
      lg: 5,
      xl: 'auto',
    },
    margin: 'auto',
    maxWidth: 1400,
    my: 10,
  },
  menuDropdownLink: {
    textDecoration: 'none',
    color: '#000000',
    fontSize: 15,
    '&:hover': {
      color: '#e3cc33',
      textDecoration: 'none',
      transition: 'color 0.3s ease',
    },
  },
  wuLogo: {
    width: {
      xs: 200,
      xl: 250,
    },
  },
  headerProfileButton: {
    color: 'white',
    textDecoration: 'none',
    fontWeight: 500,
    fontSize: 15,
    '&:hover': {
      color: '#e3cc33',
      textDecoration: 'none',
      transition: 'color 0.3s ease',
    },
  },
  headerProfileIcon: {
    mr: 2,
    width: 35,
    height: 35,
    color: '#e3cc33',
  },
  layoutMobileMenuButton: {
    display: {
      xs: 'flex',
      lg: 'none',
    },
    alignItems: 'center',
    p: '0 !important',
    m: '0 !important',
    width: 'auto',
    minWidth: 'auto',
  },
  mobileMenuWrapper: {
    position: 'fixed',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    zIndex: 10,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    transition: '0.5s',
  },
  mobileMenu: {
    height: '100vh',
    backgroundColor: 'white',
    p: 3,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  mobileMenuHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  mobileMenuCloseButton: {
    p: '0 !important',
    m: '0 !important',
    width: 'auto',
    minWidth: 'auto',
  },
  mobileMenuItemsWrapper: {
    mt: 5,
    '& a': {
      fontSize: 16,
      color: 'black',
      textDecoration: 'none',
      px: 3,
      textAlign: 'left',
      fontWeight: 300,
      justifyContent: 'start',
    },
    '& hr': {
      my: 1,
    },
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
};
